var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"botao-cancelar",attrs:{"id":"botaoCancelar","outlined":"","depressed":""},on:{"click":function($event){return _vm.$emit('cancelar')}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }